import React from "react";
import { TextInput } from "@truevault/aquilo";
import { CONSENT_INPUT_TEXT_SIZE } from "../../../consentBanner/consentFieldStyles";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";

interface ConsentBannerPreviewURLRowProps {
  formApi: {
    change: (field: string, value: string) => void;
  };
}

export const ConsentBannerPreviewURLRow = ({ formApi }: ConsentBannerPreviewURLRowProps) => {
  return (
    <ConsentSettingRow
      title="Preview page"
      helpText="The page on your website that opens with the banner on it."
    >
      <div className="w-full max-w-[440px]">
        <TextInput
          field="previewURL"
          inputTextSize={CONSENT_INPUT_TEXT_SIZE}
          aria-label="Preview page"
          placeholder="www.example.com"
          leftAddonText="https://"
          required
          onChange={(event) => {
            if (!event.target.value) {
              return;
            }

            // Remove http:// or https:// from the beginning of the URL if present
            const cleanedValue = event.target.value.replace(/^https?:\/\//i, "");
            formApi.change("previewURL", cleanedValue);
          }}
        />
      </div>
    </ConsentSettingRow>
  );
};
